export const en = `
<header>
    <h1>Legal Notice</h1>
    <p><strong>Date:</strong> June 2025</p>
    <p>Welcome to <a href="https://exposition.balenciaga.com">https://exposition.balenciaga.com</a> ("Website”).</p>
  </header>

  <section>
    <h2>Website Ownership</h2>
    <p>
      The Website is owned and operated by BALENCIAGA, a simplified joint-stock company incorporated under French law
      with a share capital of 23,271,525 €, registered with the Paris Trade and Corporate Register under unique identification
      number 775 668 122 and with registered office at 16-18 rue Vaneau, 75007 Paris, France (“Balenciaga” or “we”, “us”, “our”).
    </p>
    <p>
      The Website’s publishing director is Mr. Gianfranco Gianangeli. The Website is hosted by Amazon Web Services, Inc.,
      P.O. Box 81226, Seattle, WA 98108-1226 (tel: 001 206 266 7010).
    </p>
  </section>

  <section>
    <h2>Purpose of the Website</h2>
    <p>
      The Website gives access to content (“Content”) developed by Balenciaga and made available to its users.
    </p>
    <p>
      Please read carefully the following terms of use (“ToU”) as they govern your use of the Website, its Content, and
      more generally any Balenciaga services.
    </p>
  </section>

  <section>
    <h2>Definitions and Acceptance of the ToU</h2>
    <p>
      These ToU apply to your access to and use of the Website and the Content.
    </p>
    <p>
      The terms “you” and “your” refer to any user of the Website. The term "Content" includes all information, documentation,
      and materials available on the Website, such as design, layout, graphics, images, audio, logos, software, and more.
    </p>
    <p>
      By using the Website, you agree to these ToU. If you do not agree, you may not use the Website.
    </p>
    <p>
      Balenciaga may modify these ToU at any time. Continued use of the Website signifies your acceptance of any modified ToU.
    </p>
  </section>

  <section>
    <h2>Accessing the Website and Content</h2>
    <p>
      You are responsible for ensuring you have the required technology to access and use the Website and the Content.
    </p>
    <p>
      General access to the Website is open to all users.
    </p>
  </section>

  <section>
    <h2>Use of the Website and the Content</h2>
    <p>You agree not to:</p>
    <ul>
      <li>Interrupt or impair the Website's functioning or accessibility;</li>
      <li>Bypass security measures or tamper with the Website's technology;</li>
      <li>Access materials not publicly available via the Website;</li>
      <li>Violate any applicable laws;</li>
      <li>Use the Website unlawfully or infringe on third-party rights;</li>
      <li>Record, download, or share the Content without permission.</li>
    </ul>
    <p>
      Private individuals may consult the Content for personal use only.
    </p>
    <p>
      Any use not expressly permitted by the ToU is prohibited.
    </p>
    <p>
      We may suspend or terminate your access without notice for any breach of the ToU.
    </p>
  </section>

  <section>
    <h2>Intellectual Property Rights</h2>
    <p>
      The Website and its Content are owned or licensed by Balenciaga and protected by intellectual property laws.
      Unauthorized use may violate such laws.
    </p>
  </section>

  <section>
    <h2>Links</h2>
    <h3>Links to Third-Party Sites</h3>
    <p>
      The Website may contain links to third-party websites ("Linked Sites"). Balenciaga has no control over them and
      assumes no responsibility for their content, availability, or practices.
    </p>

    <h3>Links to Our Website</h3>
    <p>
      You may not frame or link to the Website or its Content without our prior written consent.
    </p>
  </section>

  <section>
    <h2>No Warranties</h2>
    <p>
      The Website and its Content are provided “as-is” and “as available”, without warranties of any kind. We do not
      guarantee continuous availability, error-free performance, or protection from malicious software.
    </p>
    <p>
      While we aim to ensure accurate and up-to-date information, we make no guarantees and assume no liability for any errors.
    </p>
  </section>

  <section>
    <h2>Limitation of Liability</h2>
    <p>
      To the extent permitted by law, Balenciaga shall not be liable for any damages arising from the use of, or inability
      to use, the Website or its Content, or any third-party claims.
    </p>
    <p>
      Some jurisdictions may not allow certain exclusions or limitations; in such cases, they may not apply.
    </p>
  </section>

  <section>
    <h2>Governing Law and Jurisdiction</h2>
    <p>
      These ToU are governed by the laws of France. Any disputes shall be submitted to the exclusive jurisdiction of
      the Paris Court of Appeal.
    </p>
    <p>
      In the event of discrepancies between language versions, the English version shall prevail.
    </p>
  </section>

  <section>
    <h2>Contact Us</h2>
    <p>If you have any questions about the ToU or the Website, you may contact us:</p>
    <ul>
      <li>By mail: BALENCIAGA – 16-18 rue Vaneau 75007 Paris France</li>
      <li>By telephone: +33 1 56 52 17 17</li>
    </ul>
  </section>

  <section>
    <h2>Privacy Statement</h2>
    <p>
      Balenciaga may process your personal data to operate and improve the Website. This processing follows the ToU and our
      Privacy Policy. You may have rights under privacy laws including the rights to access, rectify, delete, object to processing,
      and data portability.
    </p>
    <p>
      You may contact us regarding your data rights at: <a href="mailto:privacy@balenciaga.com">privacy@balenciaga.com</a>.
    </p>
  </section>
`

export const fr = `
<header>
    <h1>Conditions Générales d'Utilisation du Site Web</h1>
    <p><strong>Date :</strong> Juin 2025</p>
    <p>Bienvenue sur le site <a href="https://exposition.balenciaga.com">https://exposition.balenciaga.com</a> (« Site Web » ou « Site »).</p>
  </header>

  <section>
    <h2>Légal</h2>
    <p>Le Site est détenu et exploité par BALENCIAGA, une société par actions simplifiée de droit français au capital de 23.271.525 €, immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro 775 668 122, dont le siège social est situé 16-18 rue Vaneau, 75007 Paris, France (« Balenciaga » ou « nous », « notre », « nos »).</p>
    <p>Le directeur de la publication du Site est M. Gianfranco Gianangeli.</p>
    <p>Le Site est hébergé par Amazon Web Services, Inc. P.O. Box 81226, Seattle, WA 98108-1226 (tel : 001 206 266 7010).</p>
  </section>

  <section>
    <h2>Objet du Site Web</h2>
    <p>Le Site donne accès à un contenu (le « Contenu ») développé par Balenciaga et mis à la disposition des utilisateurs du Site.</p>
    <p>Veuillez lire attentivement les Conditions Générales d'Utilisation suivantes (« CGU »), qui régissent votre utilisation du Site Web, de son Contenu et de tout service Balenciaga.</p>
  </section>

  <section>
    <h2>Définitions et acceptation des CGU</h2>
    <p>Les présentes CGU s'appliquent à votre accès et à votre utilisation du Site Web et de son Contenu.</p>
    <p>Les termes « vous » et « votre » font référence à tout utilisateur du Site Web.</p>
    <p>Le terme « Contenu » désigne l'ensemble des informations, documents et éléments présents sur le Site Web, y compris son design, structure, graphismes, photographies, textes, vidéos, sons, marques, noms de domaine, logiciels, etc.</p>
    <p>En utilisant le Site Web, vous acceptez ces CGU. Si vous ne les acceptez pas, vous ne pouvez pas utiliser le Site. Balenciaga peut modifier ces CGU à tout moment, auquel cas les modifications seront publiées sur le Site. En continuant d’utiliser le Site, vous acceptez les CGU modifiées.</p>
  </section>

  <section>
    <h2>Accès au Site Web et au Contenu</h2>
    <p>Vous êtes responsable de disposer de tout équipement nécessaire pour accéder au Site. L'accès général est ouvert à tous les utilisateurs.</p>
  </section>

  <section>
    <h2>Utilisation du Site Web et du Contenu</h2>
    <p>En utilisant le Site Web, vous vous engagez à ne pas :</p>
    <ul>
      <li>interrompre ou altérer le fonctionnement du Site Web ;</li>
      <li>contourner les mesures de sécurité du Site ;</li>
      <li>accéder à des informations non accessibles au public ;</li>
      <li>violer les lois en vigueur ;</li>
      <li>utiliser le Site de façon illégale ou nuisible à des tiers ;</li>
      <li>enregistrer, télécharger ou partager le Contenu par tout moyen.</li>
    </ul>
    <p>En tant que particulier, vous pouvez consulter le Contenu pour un usage strictement privé.</p>
    <p>Toute utilisation non expressément autorisée est interdite. Nous nous réservons le droit de suspendre ou résilier votre accès au Site à tout moment, sans préavis, en cas de violation des CGU.</p>
  </section>

  <section>
    <h2>Droits de propriété intellectuelle</h2>
    <p>Le Site Web et le Contenu sont la propriété de Balenciaga ou sous licence. Ils sont protégés par les lois de propriété intellectuelle. Toute utilisation non autorisée est interdite.</p>
  </section>

  <section>
    <h2>Liens</h2>
    <h3>Liens vers des sites tiers</h3>
    <p>Le Site peut contenir des liens vers des sites tiers (« Sites Liés »). Balenciaga décline toute responsabilité concernant ces Sites Liés et leur contenu.</p>

    <h3>Liens vers notre Site Web</h3>
    <p>Il est interdit de créer un lien vers notre Site ou d’en intégrer le contenu ailleurs sans notre autorisation écrite préalable.</p>
  </section>

  <section>
    <h2>Aucune garantie</h2>
    <p>Le Site est fourni « en l'état » et « selon la disponibilité ». Balenciaga n’offre aucune garantie concernant la disponibilité, l'absence d'erreurs, ou la sécurité du Site. Les informations fournies ne sont pas garanties sans erreur ou omission.</p>
  </section>

  <section>
    <h2>Limitation de la responsabilité</h2>
    <p>Balenciaga ne pourra être tenu responsable des dommages directs ou indirects liés à l’utilisation ou à l’impossibilité d’utilisation du Site ou du Contenu. Cette limitation s’applique dans les limites permises par la loi. Certaines exclusions peuvent ne pas s’appliquer selon les juridictions.</p>
  </section>

  <section>
    <h2>Droit applicable et juridiction</h2>
    <p>Les CGU sont régies par le droit français. Tout litige est soumis à la juridiction exclusive des tribunaux de la Cour d’appel de Paris. En cas de divergence entre les versions linguistiques, la version anglaise prévaudra.</p>
  </section>

  <section>
    <h2>Nous contacter</h2>
    <p>Pour toute question :</p>
    <ul>
      <li>Par courrier : BALENCIAGA, 16-18 rue Vaneau, 75007 Paris, France</li>
      <li>Par téléphone : +33 1 56 52 17 17</li>
    </ul>
  </section>

  <section>
    <h2>Déclaration de confidentialité</h2>
    <p>Balenciaga peut traiter vos données personnelles pour administrer, optimiser et sécuriser le Site. Ce traitement respecte notre <a href="mailto:privacy@balenciaga.com">Politique de Confidentialité</a>. Vous disposez de droits d'accès, de suppression, de rectification, de portabilité, etc. Vous pouvez également contacter l’autorité compétente.</p>
  </section>
`
